// NOM
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

// ANT COMPONENT
import { BankOutlined, UserOutlined } from '@ant-design/icons';
import { Card, Col, Row } from 'antd';

// STYLE
import "./customer-profile-create-selection.scss";
import "./../customer-management.scss";

interface CustomerProfileCreateSelectionComponentProps {

}

const CustomerProfileCreateSelectionComponent: 
React.FC<CustomerProfileCreateSelectionComponentProps> = ({

}) => {

    const { t } = useTranslation();
    const history = useHistory();

    const handleRouteClick = (type: "individual" | "company") => {
        history.push(`/customer-management/profile/create/${type}`);
    }

    return (
        <div className="customer-management create-selection">
            <div className="mb-25 center header-title">{t("title.createCustomer").toUpperCase()}</div>
            <div className="mb-25 center subheader-title">{t("title.selectTypeOfCustomer")}</div>
            <Row gutter={[15, 15]}>
                <Col xs={0} sm={0} md={0} lg={6} xl={8}></Col>
                <Col xs={24} sm={24} md={12} lg={6} xl={4}>
                    <Card hoverable className="center" 
                    onClick={() => {handleRouteClick("individual")}}>
                        <UserOutlined />
                        <div className="mt-15 card-text">
                            {t("label.individual").toUpperCase()}
                        </div>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={12} lg={6} xl={4}>
                    <Card hoverable className="center"
                    onClick={() => {handleRouteClick("company")}}>
                        <BankOutlined />
                        <div className="mt-15 card-text">
                            {t("label.company").toUpperCase()}
                        </div>
                    </Card>
                </Col>
                <Col xs={0} sm={0} md={0} lg={6} xl={8}></Col>
            </Row>
        </div>
    )
}

export default CustomerProfileCreateSelectionComponent;